import React, { Component } from 'react';

import "./index.scoped.css";
export default function Dev() {
    return (
        <div id="dev">
            <div className="devWrap">
                <ul className="mdui-list mdui-list-dense" mdui-collapse="{accordion: true}">
                    <li className="mdui-collapse-item">
                        <div className="mdui-collapse-item-header mdui-list-item mdui-ripple">
                            <i className="mdui-list-item-icon mdui-icon material-icons">bug_report</i>
                            <div className="mdui-list-item-content">Bug</div>
                            <i className="mdui-collapse-item-arrow mdui-icon material-icons">keyboard_arrow_down</i>
                        </div>
                        <ul className="mdui-collapse-item-body mdui-list mdui-list-dense">
                            <li className="mdui-list-item mdui-ripple ">连续同步操作 reaction 反应不过来</li>
                            {/* <li className="mdui-list-item mdui-ripple over">连续同步操作 reaction 反应不过来</li> */}
                        </ul>
                    </li>
                    <li className="mdui-collapse-item mdui-collapse-item-open idea">
                        <div className="mdui-collapse-item-header mdui-list-item mdui-ripple">
                            <i className="mdui-list-item-icon mdui-icon material-icons">device_hub</i>
                            <div className="mdui-list-item-content">idea</div>
                            <i className="mdui-collapse-item-arrow mdui-icon material-icons">keyboard_arrow_down</i>
                        </div>
                        <ul className="mdui-collapse-item-body mdui-list mdui-list-dense">
                            {/* <li className="mdui-list-item mdui-ripple">移动端 左滑拉出</li> */}
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="time-line-wrap">
                <ul className='time-line'>
                    <li className='timeline-header is-completed'>
                        <div className="dot"></div>
                        <span className='time mdui-text-color-theme-secondary'>2019.09.25</span>
                        <div className='title'>Ver 1.0</div>
                    </li>
                    <div className='list-content'>
                        <div className="body mdui-text-color-theme-text">重构,补充更多数据源</div>
                    </div>
                    <li className='timeline-header is-completed'>
                        <div className="dot"></div>
                        <span className='time mdui-text-color-theme-secondary'>2019.07.20</span>
                        <div className='title'>Ver 0.95</div>
                    </li>
                    <div className='list-content'>
                        <div className="body mdui-text-color-theme-text">补充图片素材</div>
                    </div>
                    <li className='timeline-header is-completed'>
                        <div className="dot"></div>
                        <span className='time mdui-text-color-theme-secondary'>2019.07.12</span>
                        <div className='title'>Ver 0.9</div>
                    </li>
                    <div className='list-content'>
                        <div className="body mdui-text-color-theme-text">框架逻辑完成</div>
                    </div>
                    <li className='timeline-header is-completed'>
                        <div className="dot"></div>
                        <span className='time mdui-text-color-theme-secondary'>2019.07.10</span>
                        <div className='title'>Ver 0.8</div>
                    </li>
                    <div className='list-content'>
                        <div className="body mdui-text-color-theme-text">修复百度地图 InfoBox 库 两个Bug</div>
                    </div>
                    <li className='timeline-header is-completed'>
                        <div className="dot"></div>
                        <span className='time mdui-text-color-theme-secondary'>2017.06.30</span>
                        <div className='title'>Ver 0.4</div>
                    </li>
                    <div className='list-content'>
                        <div className="body mdui-text-color-theme-text">Redux -&gt; Mobx</div>
                    </div>
                    <li className='timeline-header is-completed'>
                        <div className="dot"></div>
                        <span className='time mdui-text-color-theme-secondary'>2019.05.21</span>
                        <div className='title'>Ver 0.1</div>
                    </li>
                    <div className='list-content'>
                        <div className="body mdui-text-color-theme-text">Hello World</div>
                    </div>
                </ul>
            </div>
        </div>
    );
}
